import { render, staticRenderFns } from "./DashboardClienteHanes.vue?vue&type=template&id=56a46a9d&scoped=true&"
import script from "./DashboardClienteHanes.vue?vue&type=script&lang=js&"
export * from "./DashboardClienteHanes.vue?vue&type=script&lang=js&"
import style0 from "./DashboardClienteHanes.vue?vue&type=style&index=0&id=56a46a9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a46a9d",
  null
  
)

export default component.exports